import { GetGameResponse } from "../../../../api/types";
import PoolHeader from "../../../../uikit/PoolHeader/PoolHeader";
import { classNames } from "../../../../utils";
import PoolGames from "../PoolGames/PoolGames";

interface PoolGameListProps {
  games: GetGameResponse[];
  onGameClick: (game: GetGameResponse) => void;
}

interface PoolGroup {
  poolId: string;
  poolName: string;
  games: GetGameResponse[];
}

const PoolGameList = ({ games, onGameClick }: PoolGameListProps) => {
  // Group games by pool
  const poolGroups: PoolGroup[] = [];

  games?.forEach((game) => {
    const poolId = game.pool;
    const poolName =
      game.phase.pools?.find((p) => p.id === poolId)?.name || poolId;

    let poolGroup = poolGroups.find((pg) => pg.poolId === poolId);

    if (!poolGroup) {
      poolGroup = {
        poolId,
        poolName,
        games: [],
      };
      poolGroups.push(poolGroup);
    }

    poolGroup.games.push(game);
  });

  // Sort pools by name
  poolGroups.sort((a, b) => a.poolName.localeCompare(b.poolName));

  const renderPool = (poolGroup: PoolGroup) => {
    return (
      <div key={poolGroup.poolId} className="group relative">
        <PoolHeader>{poolGroup.poolName}</PoolHeader>
        <PoolGames games={poolGroup.games} onGameClick={onGameClick} />
      </div>
    );
  };

  return (
    <div
      className={classNames(
        "gap-y-10 gap-x-6 ",
        poolGroups.length > 0
          ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:gap-x-2"
          : ""
      )}
    >
      {poolGroups.map(renderPool)}
    </div>
  );
};

export default PoolGameList;
